import '@common/polyfills/customElements'
import '@common/polyfills/closest'
import '@common/polyfills/remove'

import setDeviceClasses from '@common/setDeviceClasses/setDeviceClasses'

import '@common/onError/client/devmode'

// Ne lehessen a jobb egérgombot használni.
import '@common/contextMenuPreventer/contextMenuPreventer'

// Ne engedjünk szöveget kijelölni.
import '@common/userSelectPreventer/userSelectPreventer'

// Legfontosabb CSS beállításaink, amik kellenek az induláshoz.
import './kernel.scss'

import touch from '@common/touch/touch'

// Telefonon és tableten a duplakattos és a kétujjas zoomot gátoljuk ezzel.
touch.preventMultiTouch('body')

// F4 lenyomására a html-re debug class-t rak, amit lehet figyelni css-ben és extra infókat mutatni.
// Ez most production-ben is bent marad.
document.addEventListener('keydown', (e: KeyboardEvent) => {
  if (e.key === 'F4') {
    document.querySelector('html')?.classList.toggle('debug')
  }
  else if (e.key === 'F1') {
    document.querySelector('html')?.classList.toggle('grid')
  }
})

setDeviceClasses()
